var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWill = function SvgWill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.707 11.415v11.352c0 .429.286.81.62.81H6.86V10.604H1.327c-.334 0-.62.334-.62.81Z",
    fill: "#851A92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.505 8.982H16.97V4.07A3.247 3.247 0 0 0 13.727.826h-2.433c-.429 0-.81.382-.81.811V5.5l-3.148 5.486c-.096.143-.096.238-.096.381v11.4c0 .429.382.81.811.81H21.12a3.259 3.259 0 0 0 2.957-1.907l2.623-5.867a.884.884 0 0 0 .096-.334v-3.243c-.048-1.813-1.526-3.244-3.291-3.244Z",
    fill: "#AD5BB7"
  })));
};

export default SvgWill;